<template>
	<div class="modal-window" :class="[modalInfo.type, boardType, tenantId]">
    <header class="modal-header">
      <div class="tit">
				{{ modalInfo.type === "BOARD_CREATE" ? "보드" : "보드 업데이트" }}&nbsp;&nbsp;({{ userStatDetail.length }}건)<br /><br />
				{{ startDate }} ~ {{ endDate }}<br />
				{{ modalInfo.item.USER_NAME }} ({{ modalInfo.item.DEPT_NAME }})
      </div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>

    <div class="modal-content" style="padding-top: 50px; overflow-y:auto;">
      <div class="tab_ty1" id="tabsTy1">
        <ul class="tab-menu">
          <li
            v-for="(tab, index) in tabsTy1" :key="index"
            v-bind:class="{ active: tab.type === boardType }"
          >
            <button type="button" v-on:click="boardType = tab.type">
              {{ tab.value }}
            </button>
          </li>
        </ul>
        <div class="tab-content">
          <v-data-table
            :headers="headers"
            :items="selectedList"
            :itemsPerPage="paging.perSize"
            :must-sort="true"
            :disable-pagination="true"
            hide-default-footer
            class="tb-monitor-contents"
          >
						<template slot="no-data" v-if="totalCnt == 0">
							<div class="nodata-txt-noicon">
								<v-alert :value="true">
									데이터가 없습니다.
								</v-alert>
							</div>
						</template>
					</v-data-table>

					<!-- <div v-show="pageCount > 0" class="pagination">
						<v-pagination
							v-model="paging.page"
							circle
							:length="pageCount"
							@input="getUserStatListByDate"
							:total-visible="7"
						></v-pagination>
					</div> -->
				</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import SelectBox from "./common/SelectBox";
import { sortBy } from 'lodash/core';

export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
    SelectBox,
  },
	props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      sharUse: localStorage.getItem("sharUse") || "false",
      cfrcUse: localStorage.getItem("cfrcUse") || "false",
      tenantId: localStorage.getItem("tenantId"),
      todo: this.tenantId != "418502" ? "할 일" : "Task",
      workspace: this.tenantId != "418502" ? "과제" : "협업공간",
      okr: this.tenantId != "418502" ? "OKR" : "Work",
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      tabsTy1: [],
      pageCount: 1,
      headers: [],
      startDate: null,
      endDate: null,
      startDisabledDate: {
        to: new Date(this.$moment().subtract(90, "days")), // 이후 선택 기간 제한
        from: new Date(this.$moment()), //이전 선택 기간 제한
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(90, "days")),
        from: new Date(this.$moment()), //이전 선택 기간 제한
      },
      paging: {
        page: 1,
        perSize: 1000000000,
      },
      sortBy: 'STAT_DAY',
      sortDesc: true,
      totalCnt: 0,
      userStatDetail: [],
      selectedList: [],
      searchKeyword: '',
      boardType: null,
      todo: null,
      columnsInfo: []
    };
  },
  created() {
		this.startDate = this.$moment(this.modalInfo.startDate).format("YYYY-MM-DD");
		this.endDate = this.$moment(this.modalInfo.endDate).format("YYYY-MM-DD");
    

    let workspace = this.tenantId === "418502" ? "협업" : "과제";
    this.todo = this.tenantId === "418502" ? "Task" : "할 일";

    if(this.sharUse == 'true' && this.cfrcUse == 'true') {
      this.tabsTy1 = [{type: "PRO", value: workspace+"보드"}, {type: "SHAR", value: "정보 보드"}, {type: "CFRC", value: "회의 보드"}, {type: "USER", value: "프라이빗 보드"}]
      }else{
      this.tabsTy1 = [{type: "PRO", value: workspace+"보드"}, {type: "USER", value: "프라이빗 보드"}]
    }

    this.getDataColumnsInfo();
    // this.getUserStatDetail();
  },
  watch: {
    sortDesc() {
      // this.getUserStatListByDate();
    },
    sortBy() {
      // this.getUserStatListByDate();
    },
    startDate() {
      if(this.endDate < this.startDate) {
        // alert("시작일이 종료일보다 큽니다. 다시 선택해주세요.");
        // return ;
        this.endDate = this.startDate;
      }
      // this.getUserStatListByDate();
    },
    endDate() {
      if(this.endDate < this.startDate) {
        this.startDate = this.endDate;
      }
      // this.getUserStatListByDate();
    },
    setDisabledDate() {
      this.startDisabledDate.from = new Date(this.$moment().subtract(91, "days"));
      this.endDisabledDate.to = this.$moment();
    },
    searchKeyword() {
      // this.getUserStatListByDate();
    },
    boardType() {
      this.headers = [];
      
      if(this.boardType === 'PRO') {
        this.headers.push({ text: this.tenantId != "418502" ? "과제명" : "협업공간명", value: 'PROJECT_NAME', sortable: false })
      }else if(this.boardType === 'USER') {
        this.headers.push({ text: "프라이빗 공간자명", value: 'USER_NAME', sortable: false })
      }else {
        this.headers.push({ text: "카테고리명", value: 'CATEGORY_NAME', sortable: false })
      }

      let headerList;
      if(this.modalInfo.type === 'BOARD_CREATE') {
        headerList = [
          { text: "보드명", value: 'PAPER_NAME', sortable: false },
          // { text: "공개여부", value: 'DOC_GRADE', sortable: false },
          { text: "생성일", value: 'STAT_DAY', sortable: false },
          // { text: "멤버", value: 'MEMBER_CNT', sortable: false },
          { text: "조회", value: 'BOARD_ACCESS', sortable: false },
          { text: "생성자", value: 'USER_NAME', sortable: false },
          { text: "사번", value: 'USER_ID', sortable: false },
          { text: "부서", value: 'DEPT_NAME', sortable: false },
        ];
      }else {
        let proHeaderList;
        let userHeaderList;

        if(this.sharUse == 'true' && this.cfrcUse == 'true') {
          proHeaderList = [
            { text: "보드명", value: 'PAPER_NAME', sortable: false },
            // { text: "공개여부", value: 'DOC_GRADE', sortable: false },
            { text: "회의 협의 게시", value: 'POST_CFRC', sortable: false },
            { text: "정보공유 게시", value: 'POST_SHAR', sortable: false },
            { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
            { text: "피드백 요청", value: 'FEEDBACK_REQUEST', sortable: false },
            { text: this.okr+"연결", value: 'OKR_LINK', sortable: false },
            { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
            { text: "표", value: 'TABLE_ADD', sortable: false },
            { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
            { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
            { text: "링크", value: 'LINK_ADD', sortable: false },
            // { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
            { text: "의사결정", value: 'DECISION_ADD', sortable: false },
            { text: "산출물", value: 'PRODUCT', sortable: false },
            { text: "조회", value: 'BOARD_ACCESS', sortable: false },
            { text: "총 건수", value: 'TOTAL', sortable: false },
          ];

          userHeaderList = [
            { text: "보드명", value: 'PAPER_NAME', sortable: false },
            { text: "회의 협의 게시", value: 'POST_CFRC', sortable: false },
            { text: "정보공유 게시", value: 'POST_SHAR', sortable: false },
            { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
            { text: "피드백 요청", value: 'FEEDBACK_REQUEST', sortable: false },
            { text: this.okr+"연결", value: 'OKR_LINK', sortable: false },
            { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
            { text: "표", value: 'TABLE_ADD', sortable: false },
            { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
            { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
            { text: "링크", value: 'LINK_ADD', sortable: false },
            // { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
            { text: "의사결정", value: 'DECISION_ADD', sortable: false },
            { text: "산출물", value: 'PRODUCT', sortable: false },
            { text: "조회", value: 'BOARD_ACCESS', sortable: false },
            { text: "총 건수", value: 'TOTAL', sortable: false },
          ];

        }else {
          if(this.tenantId === '203') {
            proHeaderList = [
              { text: "보드명", value: 'PAPER_NAME', sortable: false },
              // { text: "공개여부", value: 'DOC_GRADE', sortable: false },
              { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
              { text: "피드백 요청", value: 'FEEDBACK_REQUEST', sortable: false },
              { text: this.okr+"연결", value: 'OKR_LINK', sortable: false },
              { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
              { text: "표", value: 'TABLE_ADD', sortable: false },
              { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
              { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
              { text: "링크", value: 'LINK_ADD', sortable: false },
              // { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
              { text: "의사결정", value: 'DECISION_ADD', sortable: false },
              { text: "산출물", value: 'PRODUCT', sortable: false },
              { text: "조회", value: 'BOARD_ACCESS', sortable: false },
              { text: "총 건수", value: 'TOTAL', sortable: false },
            ];

            userHeaderList = [
            { text: "보드명", value: 'PAPER_NAME', sortable: false },
            { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
            { text: "피드백 요청", value: 'FEEDBACK_REQUEST', sortable: false },
            { text: this.okr+"연결", value: 'OKR_LINK', sortable: false },
            { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
            { text: "표", value: 'TABLE_ADD', sortable: false },
            { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
            { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
            { text: "링크", value: 'LINK_ADD', sortable: false },
            // { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
            { text: "의사결정", value: 'DECISION_ADD', sortable: false },
            { text: "산출물", value: 'PRODUCT', sortable: false },
            { text: "조회", value: 'BOARD_ACCESS', sortable: false },
            { text: "총 건수", value: 'TOTAL', sortable: false },
          ];
          }else{ 
            proHeaderList = [
              { text: "보드명", value: 'PAPER_NAME', sortable: false },
              // { text: "공개여부", value: 'DOC_GRADE', sortable: false },
              { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
              { text: this.okr+"연결", value: 'OKR_LINK', sortable: false },
              { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
              { text: "표", value: 'TABLE_ADD', sortable: false },
              { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
              { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
              { text: "링크", value: 'LINK_ADD', sortable: false },
              // { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
              { text: "의사결정", value: 'DECISION_ADD', sortable: false },
              { text: "산출물", value: 'PRODUCT', sortable: false },
              { text: "조회", value: 'BOARD_ACCESS', sortable: false },
              { text: "총 건수", value: 'TOTAL', sortable: false },
            ];

            userHeaderList = [
              { text: "보드명", value: 'PAPER_NAME', sortable: false },
              { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
              { text: this.okr+"연결", value: 'OKR_LINK', sortable: false },
              { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
              { text: "표", value: 'TABLE_ADD', sortable: false },
              { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
              { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
              { text: "링크", value: 'LINK_ADD', sortable: false },
              // { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
              { text: "의사결정", value: 'DECISION_ADD', sortable: false },
              { text: "산출물", value: 'PRODUCT', sortable: false },
              { text: "조회", value: 'BOARD_ACCESS', sortable: false },
              { text: "총 건수", value: 'TOTAL', sortable: false },
            ];
          }
        }

        let sharHeaderList = [
          { text: "보드명", value: 'PAPER_NAME', sortable: false },
          // { text: "공개여부", value: 'DOC_GRADE', sortable: false },
          { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
          { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
          { text: "표", value: 'TABLE_ADD', sortable: false },
          { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
          { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
          { text: "링크", value: 'LINK_ADD', sortable: false },
          // { text: "좋아요", value: 'LIKE_CNT', sortable: false },
          { text: "조회", value: 'BOARD_ACCESS', sortable: false },
          { text: "총 건수", value: 'TOTAL', sortable: false },
        ]

        let cfrcHeaderList = [
          { text: "보드명", value: 'PAPER_NAME', sortable: false },
          // { text: "공개여부", value: 'DOC_GRADE', sortable: false },
          { text: "복제 건수", value: 'BOARD_COPY', sortable: false },
          { text: "파일/이미지", value: 'FILE_ADD', sortable: false },
          { text: "표", value: 'TABLE_ADD', sortable: false },
          { text: "호출", value: 'BOARD_CALL_SEND', sortable: false },
          { text: "의견/답변", value: 'BOARD_COMMENT', sortable: false },
          { text: "링크", value: 'LINK_ADD', sortable: false },
          { text: this.todo, value: 'TODO_RECEIVE', sortable: false },
          { text: "의사결정", value: 'DECISION_ADD', sortable: false },
          { text: "산출물", value: 'PRODUCT', sortable: false },
          { text: "조회", value: 'BOARD_ACCESS', sortable: false },
          { text: "총 건수", value: 'TOTAL', sortable: false },
        ]

        if(this.boardType === 'PRO') {
          headerList = proHeaderList;
        }else if(this.boardType === 'USER') {
          headerList = userHeaderList;
        }else if(this.boardType === 'SHAR') {
          headerList = sharHeaderList;
        }else if(this.boardType === 'CFRC') {
          headerList = cfrcHeaderList;
        }
      }

      headerList.forEach(header => {
        this.headers.push(header);
      })

      this.selectedList = [];
      this.userStatDetail.forEach(board => {
        if(board.BOARD_TYPE === this.boardType) {
          this.selectedList.push(board);
        }
      })
    },
    selectedList() {
      if(this.boardType === 'PRO') {
        return _.sortBy(this.selectedList, 'PROJECT_NAME');
      }else if(this.boardType === 'USER') { 
        return _.sortBy(this.selectedList, 'USER');
      }else {
        return _.sortBy(this.selectedList, 'CATEGORY_NAME');
      }
    }
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal"]),

    getDataColumnsInfo() {
      let obj = this;
      let reqData = {
        url : "/api/monitor/stat/getDataColumnsInfo",
        method : "post",
        params : {
          item: "board"
        }
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.errorCode != null) {
          console.log(res.errorCode);
        }else{
          obj.columnsInfo = res.result;
          obj.columnsInfo.push('TODO_RECEIVE');
          obj.getUserStatDetail();
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getUserStatDetail() {
      this.objStatList = [];

      let obj = this;
      let reqData = {
        url : "/api/monitor/stat/getUserStatDetail",
        method : "post",
        params : {
          startDate: obj.$moment(this.startDate).format("YYYY-MM-DD"),
          endDate: obj.$moment(this.endDate).format("YYYY-MM-DD"), // obj.$moment(this.endDate).add(1, "day").format("YYYY-MM-DD"),
          page: obj.paging.page - 1,
          perSize: obj.paging.perSize,
          sortDesc: obj.sortDesc,
          sortBy: obj.sortBy,
          searchKeyword: obj.searchKeyword,
					type: obj.modalInfo.type,
					target: obj.modalInfo.item.USER_ID,
        }
      };
      obj.COWORK_REST_SIMPLE_ACTION(reqData)
      .then(function(res) {
        if(res.errorCode != null) {
          console.log(res.errorCode);
        }else{
          let data = res.result;
          // let keyList = ['POST_CFRC', 'POST_SHAR', 'BOARD_COPY', 'FEEDBACK_REQUEST', 'OKR_LINK', 'FILE_ADD', 'TABLE_ADD', 'BOARD_CALL_SEND', 'BOARD_COMMENT', 'LINK_ADD', 'TODO_RECEIVE', 'DECISION_ADD', 'PRODUCT', 'BOARD_ACCESS'];
          let list = data.list;
          list.forEach(item => {
            for(let key in item) {
              for(var i=0; i<obj.columnsInfo.length; i++) {
                if(key === obj.columnsInfo[i]) {
                  item.TOTAL += item[key];
                }
              }
            }
          })
          obj.userStatDetail = list;
          obj.totalCnt = data.totalCnt;
          // obj.pageCount = obj.totalCnt % obj.paging.perSize === 0 ? (obj.totalCnt/obj.paging.perSize) : Math.floor(obj.totalCnt/obj.paging.perSize) + 1;
          obj.boardType = "PRO"; // default val setting
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
	}
}
</script>

<style scoped>

.modal-window >>> tbody::before,
.modal-window >>> tbody::after {
    width: 0px !important;
}
.tb-monitor-contents >>> tr {
    /* display: table-row; */
    border-bottom: 1px solid #d9d9d9;
}
.tb-monitor-contents >>> tr td {
    text-align: center;
}
.tb-monitor-contents >>> tr:hover::before {
    display: none; content: '';
    position: absolute; left: 0; top: -1px;
    width: calc(100%); height: calc(100% + 2px);
    box-shadow: 1px 1.7px 3px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #000000;
    z-index: 10;
    pointer-events: none;
}
.tb-monitor-contents >>> tbody::before, .tb-monitor-contents >>> tbody::after {
    position: absolute;
    top: 45px;
    display: none;
    content: '';
    width: 25px;
    height: calc(100% - 45px);
    background-color: #fff;
    z-index: 1;
}
.modal-window >>> th.text-center {
  text-align: center;
}
.modal-window >>> input {
  background-color: transparent;
}

.tb-monitor-contents >>> {
    border-top: 1px solid #d3d4d6;
    border-bottom: 1px solid #d3d4d6;
    background-color: #fff;
}
.tb-list_ty1 .tb-monitor-contents >>> {
    border-top: 0 none;
    border-bottom: 0 none;
}
.tb-monitor-contents.nodata {
    position: relative;
    height: 406px;
}
.tb-monitor-contents >>> td > .nodata-txt {
    padding: 150px 0;
    font-size: 14px; color: #999; text-align:center
}
.tb-monitor-contents.nodata .nodata-txt {
    position: absolute; left: calc(50%); top: calc(50% - 47px);
    height: 94px; padding-top: 79px;
    font-size:14px; color: #999
}
.tb-monitor-contents.nodata .nodata-txt::before,
.tb-monitor-contents.nodata .nodata-txt::after {
    display: block; content: '';
}
.tb-monitor-contents.nodata .nodata-txt::before {
    position: absolute; left: calc(50% - 32px); top:0;
    width: 64px; height: 64px;
    border: solid 1px #d3d4d6; border-radius: 50%;;
}
.tb-monitor-contents >>> {
    width: 100%;
    font-size: 14px;
}
.tb-monitor-contents >>> .thead .th,
.tb-monitor-contents >>> thead th {
    display: table-cell;
    height: 44px; padding: 12px 0px;
    font-size: 12px; color: #999; vertical-align: middle; text-align: center;
}
.tb-monitor-contents >>> .thead .th,
.tb-monitor-contents >>> thead th {border-bottom: 1px solid #d3d4d6}
.tb-monitor-contents >>> .tr:first-child,
.tb-monitor-contents >>> tr:first-child {border-top: 0 none;}
.tb-monitor-contents >>> th span.sort.up {background-position: -70px -221px;}
.tb-monitor-contents >>> th span.sort.dn {
    background-position: -70px -221px;
    transform: rotate(-180deg);
}

.tb-monitor-contents >>> tbody > .tr:hover,
.tb-monitor-contents >>> tbody > tr {position: relative;}
/* .tb-monitor-contents >>> tbody > .tr:hover::before,
.tb-monitor-contents >>> tbody > tr:hover::before {
    display: block; content: '';
    position: absolute; left: 0; top: -1px;
    width: calc(100% - 1px); height: calc(100% + 2px);
    box-shadow: 1px 1.7px 3px 0 rgba(0, 0, 0, 0.15);
    border: solid 1px #000000;
    z-index: 10;
    pointer-events: none;
} */
.tb-monitor-contents.hover-none tbody > .tr:hover::before,
.tb-monitor-contents.hover-none tbody > tr:hover::before {
    display: none;
    width: 0; height: 0;
    box-shadow: none;
    border: 0 none;
}
/* .tb-monitor-contents >>> .tr,
.tb-monitor-contents >>> tr {
    display: table;
    width: 100%;
    border: 1px solid transparent;
    border-top: 1px solid #d3d4d6;
} */
.tb-monitor-contents >>> table,
table.tb-monitor-contents >>> {position: relative;}
.tb-monitor-contents >>> tbody::before,
.tb-monitor-contents >>> tbody::after {
    position: absolute; top: 45px;
    display: block; content: '';
    width: 25px; height: calc(100% - 45px);
    background-color: #fff;
    z-index: 1;
}
.tb-monitor-contents >>> tbody::before {left:0;}
.tb-monitor-contents >>> tbody::after {right:0}
.tb-monitor-contents >>> td .member .name.v-btn {font-size: 12px; color: #999;}
.tb-monitor-contents >>> td .droplayer.member > .v-menu {left: auto !important; right: 0;}
.tb-monitor-contents >>> td .droplayer.member .v-menu__content {
    left: auto !important; right: 0;
    border:0 none;
    box-shadow: none;
}
.tb-monitor-contents >>> td .droplayer.member .tooltip-b.tl::before {left: auto; right: 10px;}
.tb-monitor-contents >>> .td,
.tb-monitor-contents >>> td {
    display: table-cell;
    height: 55px; padding: 12px 0px;
    vertical-align:middle;
}
.tb-monitor-contents >>> tr.disabled td {color: #bbb;}
.tb-monitor-contents >>> .subject {color: #000; cursor: pointer;}
.tb-monitor-contents >>> .subject > .txt + .reason:empty {display: none;}
.tb-monitor-contents >>> .re-de {font-size: 12px;}
.tb-monitor-contents >>> .date {font-size: 12px; color: #999;}
.tb-monitor-contents >>> .re {color: #999}
.tb-monitor-contents >>> .del * {color: #bbb}
.tb-monitor-contents >>> .del .subject .txt,
.tb-monitor-contents >>> .del .subject .re,
.tb-monitor-contents >>> .del .subject .de {text-decoration: line-through;}
.tb-monitor-contents >>> .subject .reason {
    margin-top: 10px;
    font-size: 12px; text-decoration: none;
}
.tb-monitor-contents >>> .division {background-position: -210px -221px;}
.tb-monitor-contents >>> .del .division {background-position: -60px -221px;}

.tb-monitor-contents >>> .request .request {color: #fd7201}
.tb-monitor-contents >>> .fin .fin {color: #a2c10b}
.tb-monitor-contents >>> .date.deadline {color: #fF0000}
.tb-monitor-contents >>> .author {font-size:12px; color:#999;}
.tb-monitor-contents >>> .author .v-btn {font-size:12px; color:#999;}

.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu {top: auto; bottom: 30px}
.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .v-menu__content,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .v-menu__content {top: auto !important; bottom: 0}

.ins002a .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu,
.ins002a .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu {bottom: 29px}
.ins002a .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .v-menu__content,
.ins002a .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .v-menu__content {top: auto !important; bottom: 0}

.bds041 .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu,
.bds041 .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu {bottom: 20px}
.bds041 .tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .v-menu__content,
.bds041 .tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .v-menu__content{top: auto !important; bottom: 0}

.tb-monitor-contents >>> tr:last-child .droplayer.tooltipmember > .v-menu,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer.tooltipmember > .v-menu {bottom: 17px}
.tb-monitor-contents >>> tr:last-child .droplayer.tooltipmember > .v-menu .v-menu__content,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer.tooltipmember > .v-menu .v-menu__content {top: auto !important; bottom: 0}


.tb-monitor-contents >>> tr:first-child .droplayer.tooltipmember > .v-menu {bottom: auto !important;}
.tb-monitor-contents >>> tr:first-child .droplayer.tooltipmember > .v-menu .v-menu__content,
.tb-monitor-contents >>> tr:first-child .droplayer.tooltipmember > .v-menu .v-menu__content {bottom: auto !important; bottom: 0}

.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .tooltip-b,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .tooltip-b {margin-top: 0; margin-bottom: 7px}
.tb-monitor-contents >>> tr:last-child .droplayer > .v-menu .tooltip-b::before,
.tb-monitor-contents >>> tr:nth-last-child(2) .droplayer > .v-menu .tooltip-b::before {
    top:auto; bottom: -7px;
    transform: rotate(180deg);    
}

.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu {bottom:auto; top: 20px}
.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu .v-menu__content {bottom:auto; top: 0}
.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu .tooltip-b {margin-top: 7px; margin-bottom: 0}
.tb-monitor-contents >>> tr:last-child:first-child .droplayer > .v-menu .tooltip-b::before {
    top: -7px; bottom: auto;
    transform: rotate(0);    
}

.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu {bottom:auto; top: 20px}
.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu .v-menu__content {bottom:auto; top: 0}
.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu .tooltip-b {margin-top: 7px; margin-bottom: 0}
.tb-monitor-contents >>> tr:first-child .droplayer > .v-menu .tooltip-b::before {
    top: -7px; bottom: auto;
    transform: rotate(0);    
}


.tb-monitor-contents >>> tr.v-data-table__empty-wrapper td {width: 100% !important; height: 376px !important; padding: 0}
.tb-monitor-contents >>> tr.v-data-table__empty-wrapper:hover::before {
    content: inherit;
    width:0; height: 0; border-color: transparent;
}
.tab_ty1 > .tab-menu {
  border: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/MonitorUserStatDetailBoard.vue